import { UnitConverter } from '../base/UnitConverter';
import { UnitOptions } from '../constants/unit.options';

export class FrequencyUnitConverter extends UnitConverter<
  (typeof UnitOptions)['Frequency'][number]['value']
> {
  // 싱글턴 인스턴스
  private static instance: FrequencyUnitConverter;

  private constructor() {
    super();
  }

  static getInstance(): FrequencyUnitConverter {
    if (!FrequencyUnitConverter.instance) {
      FrequencyUnitConverter.instance = new FrequencyUnitConverter();
    }
    return FrequencyUnitConverter.instance;
  }

  protected units = [
    'hertz (Hz)',
    'kilohertz (kHz)',
    'megahertz (MHz)',
    'gigahertz (GHz)',
  ] as const;

  protected unitToBase = {
    'hertz (Hz)': 1,
    'kilohertz (kHz)': 1e3,
    'megahertz (MHz)': 1e6,
    'gigahertz (GHz)': 1e9,
  };
}
